import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "../config/brand";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-xl lg:text-2xl font-semibold text-white tracking-tight mb-4">
      {title}
    </h2>
    <div className="font-body text-sm lg:text-base text-zinc-300 leading-relaxed space-y-3">
      {children}
    </div>
  </section>
);

const Datenschutz = () => {
  useEffect(() => {
    document.title = "Datenschutzerklärung · LionPerformance";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid="page-datenschutz"
      className="min-h-screen bg-black text-white"
    >
      <header className="border-b border-white/5">
        <div className="mx-auto max-w-[900px] px-6 lg:px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src={BRAND.logo}
              alt="LionPerformance"
              className="h-9 w-9 object-contain"
              style={{ filter: "url(#lp-remove-black)" }}
            />
            <span className="font-display text-white text-base font-semibold tracking-tight">
              Lion<span className="text-primary-red">Performance</span>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 hover:text-primary-red transition-colors"
          >
            <ArrowLeft size={14} />
            Zurück
          </Link>
        </div>
      </header>

      <article className="mx-auto max-w-[900px] px-6 lg:px-8 py-14 lg:py-20">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-primary-red" />
          <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
            Rechtliches
          </span>
        </div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.05] mb-4">
          Datenschutzerklärung
        </h1>
        <p className="text-sm text-zinc-500 mb-12">
          Informationen zur Verarbeitung personenbezogener Daten
        </p>

        <Section title="Einleitung">
          <p>
            Diese Datenschutzerklärung informiert über die Verarbeitung
            personenbezogener Daten im Zusammenhang mit den Leistungen von
            Lion Performance.
          </p>
        </Section>

        <Section title="Verantwortlicher">
          <p>Marc Wiebeck</p>
          <p>Helenenstraße 19b</p>
          <p>38118 Braunschweig</p>
          <p>
            E-Mail:{" "}
            <a
              href="mailto:info@lionperformance.fit"
              className="text-white hover:text-primary-red transition-colors"
            >
              info@lionperformance.fit
            </a>
          </p>
          <p>
            Telefon:{" "}
            <a
              href="tel:+4915110662067"
              className="text-white hover:text-primary-red transition-colors"
            >
              0151 10662067
            </a>
          </p>
        </Section>

        <Section title="Verarbeitete Daten">
          <p>
            Verarbeitet werden insbesondere Daten aus Kontaktanfragen,
            Terminvereinbarungen sowie der Vertragsanbahnung und
            Vertragsdurchführung.
          </p>
        </Section>

        <Section title="Rechtsgrundlagen">
          <p>
            Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. b, c und f
            DSGVO; soweit Gesundheitsdaten verarbeitet werden, zusätzlich
            Art. 9 Abs. 2 DSGVO auf Grundlage einer Einwilligung oder
            gesetzlicher Erlaubnistatbestände.
          </p>
        </Section>

        <Section title="Empfänger">
          <p>
            Empfänger können IT-Dienstleister oder Auftragsverarbeiter sein,
            soweit dies zur Leistungserbringung erforderlich ist.
          </p>
        </Section>

        <Section title="Ihre Rechte">
          <p>
            Betroffene haben die Rechte auf Auskunft, Berichtigung, Löschung,
            Einschränkung, Datenübertragbarkeit sowie Widerspruch nach der
            DSGVO.
          </p>
          <p>
            Beschwerderecht besteht bei einer zuständigen
            Datenschutzaufsichtsbehörde.
          </p>
        </Section>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Lion Performance. Alle Rechte
            vorbehalten.
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 hover:text-primary-red transition-colors"
          >
            <ArrowLeft size={14} />
            Zurück zur Startseite
          </Link>
        </div>
      </article>
    </main>
  );
};

export default Datenschutz;
